import { Text, Stack, Switch, Button } from "prism-react";
import { useState } from "react";

import { useAnalytics } from "hooks/useAnalytics";
import { getExperiments, setExperiment } from "utils/experiments";

import { SettingItem } from "./common";

export const Experiments: React.FC = () => {
  const [_, setForceRerender] = useState<number>(0);
  const track = useAnalytics();

  const forceRerender = () => {
    setForceRerender((val) => val + 1);
  };

  const experimentsChildren: JSX.Element[] = [
    <SettingItem
      description="Enable server-side VSCode extensions for Devboxes you own (enables extension marketplace)"
      title="VS Code Server"
    >
      <Switch
        checked={getExperiments().serverExtensions}
        onCheckedChange={(value) => {
          setExperiment("serverExtensions", value);
          track("set_vscode_server", { enabled: value });
          forceRerender();
        }}
      />
    </SettingItem>,
    <SettingItem
      description="Enable the VSCode extension marketplace"
      title="Extension Marketplace"
    >
      <Switch
        checked={
          getExperiments().serverExtensions ||
          getExperiments().extensionMarketplace
        }
        onCheckedChange={(value) => {
          track("set_vscode_marketplace", { enabled: value });
          setExperiment("extensionMarketplace", value);
          if (value === false && getExperiments().serverExtensions) {
            setExperiment("serverExtensions", false);
          }
          forceRerender();
        }}
      />
    </SettingItem>,
  ];

  return (
    <Stack gap={5}>
      {experimentsChildren.length > 0 ? (
        experimentsChildren
      ) : (
        <Text color="neutral-fg-subtle">No experiments available</Text>
      )}

      <Stack css={{ justifyContent: "space-between" }} horizontal>
        <Text>Changing these settings requires a refresh </Text>
        <Button
          onClick={() => {
            document.location.reload();
          }}
          variant="secondary"
        >
          Reload editor
        </Button>
      </Stack>
    </Stack>
  );
};
